// removed by extract-text-webpack-plugin
module.exports = {"App":"App__App__3Ge-C","red":"App__red__eyQdf","bold":"App__bold__1gKsH","Red":"App__Red__1gVyX"};


//////////////////
// WEBPACK FOOTER
// ./src/App.css
// module id = 18
// module chunks = 0